<template>
  <div class="fill-width">
    <!--    First Version Caspian-->
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="!getGlobalApiRequestPending && getMobileLayout">
        <b-col cols="12">
          <HeaderNewVersion />
        </b-col>

        <b-col cols="12" class="px-0 d-flex justify-content-center">
          <b-row
            class="d-flex justify-content-center align-items-center"
            v-if="enabledMethods.length === 0 && !apiRequestPending"
          >
            <b-col
              cols="12"
              class="d-flex justify-content-center align-items-center mt-2"
            >
              <span
                class="red-text font-size-large font-weight-bold text-center"
              >
                {{ $translate("noActiveMethodsIsAvailable") }}
              </span>
            </b-col>
          </b-row>
          <b-row
            class="mt-3 d-flex justify-content-between align-items-center"
            v-if="enabledMethods.length !== 0 && !apiRequestPending"
          >
            <b-col
              v-for="(item, index) in offlineGateways"
              :key="index"
              cols="6"
              class="d-flex justify-content-center align-items-center"
            >
              <button
                :disabled="!enabledMethods.includes(item.type)"
                class="d-flex flex-column background-transparent border-none z-index-5"
                @click="selectOfflineMethod(item)"
              >
                <img
                  class="ordinary-img"
                  :src="item.imgSrc"
                  :class="{
                    'mix-blend-mode-luminosity': false,
                  }"
                  height="100"
                  width="100"
                />
                <p
                  class="mt-2 font-size-medium-small font-weight-bold fill-width"
                >
                  {{ $translate(item.translationKey) }}
                </p>
              </button>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          class="d-flex justify-content-center align-items-center mt-5 pt-5"
        >
          <span class="cornflower-blue-text font-size-large font-weight-bold">
            {{ $translate("selectYourPayMethod") }}
          </span>
        </b-col>
        <b-row class="d-flex justify-content-center align-items-center">
          <b-col
            cols="4"
            class="d-flex justify-content-center align-items-center pt-3"
          >
            <button
              type="button"
              class="new-version-decline-button"
              @click="cancelPayment"
            >
              {{ $translate("cancel") }}
            </button>
          </b-col>
        </b-row>
        <!--      <VideoPlayer v-if="showVideo" @closeVideoClickedOutSide="clickedOutSideOfVideo" :videoAddress="videoAddress"/>-->
      </b-row>
      <b-row v-if="!getGlobalApiRequestPending & !getMobileLayout">
        <DesktopLayoutHelperNewVersion>
          <template v-slot:body>
            <b-container class="m-1 p-1 pt-2">
              <b-row
                class="mt-3 d-flex justify-content-between align-items-center"
                v-if="enabledMethods.length !== 0 && !apiRequestPending"
              >
                <b-col
                  v-for="(item, index) in offlineGateways"
                  :key="index"
                  cols="6"
                  class="d-flex justify-content-center align-items-center"
                >
                  <button
                    :disabled="!enabledMethods.includes(item.type)"
                    class="d-flex flex-column background-transparent border-none z-index-5"
                    @click="selectOfflineMethod(item)"
                  >
                    <img
                      class="ordinary-img"
                      :src="item.imgSrc"
                      :class="{
                        'mix-blend-mode-luminosity': false,
                      }"
                      height="100"
                      width="100"
                    />
                    <p
                      class="mt-2 font-size-medium-small font-weight-bold fill-width"
                    >
                      {{ $translate(item.translationKey) }}
                    </p>
                  </button>
                </b-col>
              </b-row>
              <b-row class="d-flex justify-content-center">
                <b-col
                  cols="12"
                  class="d-flex justify-content-center align-items-center mt-5 pt-5"
                >
                  <span
                    class="cornflower-blue-text font-size-large font-weight-bold"
                  >
                    {{ $translate("selectYourPayMethod") }}
                  </span>
                </b-col>
                <b-col
                  cols="4"
                  class="d-flex justify-content-center align-items-center pt-3"
                >
                  <button
                    type="button"
                    class="new-version-decline-button"
                    @click="cancelPayment"
                  >
                    {{ $translate("cancel") }}
                  </button>
                </b-col>
              </b-row>
            </b-container>
          </template>
        </DesktopLayoutHelperNewVersion>
      </b-row>
    </transition>
    <!--    /First Version Caspian-->
  </div>
</template>
<script>
// import VideoPlayer from "@/components/VideoPlayer";
import DesktopLayoutHelperNewVersion from "@/components/DesktopLayoutHelperNewVersion";
import HeaderNewVersion from "@/components/HeaderNewVersion";
import { mapGetters } from "vuex";
import { indirectGroupMixin } from "../../../mixins/IndirectGroupMixin";

export default {
  name: "IndirectGroupNewVersion",
  components: {
    DesktopLayoutHelperNewVersion,
    HeaderNewVersion,
    // VideoPlayer,
  },
  mixins: [indirectGroupMixin],
  computed: {
    ...mapGetters(["getMobileLayout"]),
  },
};
</script>

<style scoped>
.go-to-next-button {
  width: 100%;
  padding: 5px;
  border: none !important;
  border-radius: 10px;
  background-color: var(--dodger-blue);
  color: var(--white);
}

.flex-centering {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wallet-address-input {
  font-size: 1rem !important;
}

@media only screen and (max-width: 1450px) {
  .wallet-address-input {
    font-size: 0.75rem !important;
  }
}

@media only screen and (max-width: 1200px) {
  .wallet-address-input {
    font-size: 0.68rem !important;
  }
}

@media only screen and (max-width: 990px) {
  .wallet-address-input {
    font-size: 0.75rem !important;
  }
}

@media only screen and (max-width: 380px) {
  .wallet-address-input {
    font-size: 0.68rem !important;
  }
}
</style>
